module.exports = __webpack_public_path__ + "static/media/Николаева Н., Манакова Н..4b0cf459.pdf";